import { Order, Price_Type, Store } from "../../models/RestModels";
import { OrderInfo, OrderItemInfo } from "../../models/models";
import { RestService } from "../../services/rest.service";
import { getEmptyStore } from './Store';

export function getOrderInfo(rest:RestService, price_type_list:Price_Type[] = [], store_list:Store[] = []): OrderInfo
{
		let price_type_id:number = (price_type_list?.length ) ? price_type_list[0].id : 1; //Posible error
		let tax_percent = 0;

		let store:Store | undefined = store_list.find(store=>store.id == rest?.current_user?.store_id )

		if( !store )
			store = getEmptyStore();

		let version_created = rest.getVersion();

		let items:OrderItemInfo[] = [];
		let order:Order = {
			amount_paid: 0,
			ares: 0,
			billing_data_id: store.default_billing_data_id,
			cashier_user_id: rest?.current_user?.id,
			created: new Date(),
			cancellation_timestamp: null,
			closed_timestamp: null,
			currency_id: 'MXN',
			discount: 0,
			external_id: null,
			delivery_schedule: null,
			discount_calculated: 0,
			price_type_id: price_type_id,
			sat_serie: store.default_sat_serie,
			sat_exchange_rate: 1,
			sat_factura_id: null,
			service_type: 'QUICK_SALE',
			status: 'PENDING',
			cancellation_reason: '',
			cancelled_by_user_id: null,
			paid_status:'PENDING',
			period_id: null,
			guests: 1,
			lat:null,
			lng:null,
			sat_isr: 0,
			sat_ieps: 0,
			sat_forma_pago: '99',
			marked_for_billing:'NO',
			delivery_status: 'PENDING',
			sat_regimen_fiscal_receptor: '',
			sat_regimen_capital_receptor: '',
			sat_domicilio_fiscal_receptor: '',
			store_id: rest?.current_user?.store_id || store.id,
			subtotal: 0,
			sync_id: rest.getSyncId(),
			sync_uuid: rest.getUUID(),
			system_activated: null,
			table_id: null,
			tag:'',
			tax: 0,
			tax_percent:tax_percent,
			total: 0,
			updated: new Date(),
			version_created,
			version_updated: version_created
		};

		let empty:OrderInfo = {
			cashier: rest.current_user,
			client: null,
			delivery_user: null,
			items,
			offers:[],
			order,
			purchase: null,
			sat_factura: null,
			store: store,
			structured_items:[],
		};
		return empty;
}
